import type { RouteObject } from 'react-router';

/**
 * One route, `/search`, carrying the query as `?q=` (FR-004, research R-007). **No query text ever
 * occupies a path segment** — the same rule 011 R-002 applied to tag names, and here it is what
 * keeps `?`, `#`, `/` and a leading space in a query from needing an encoding convention.
 *
 * `q` reached `SearchPage`'s input through `withComponentInputBinding()` in `app.config.ts`, which
 * bound query parameters as well as path parameters. **That binding is gone and nothing replaced
 * it**: the page reads `useSearchParams()` itself, so a route that forgot to wire the parameter is
 * no longer a state this file can be in.
 */
export const routes: RouteObject[] = [
  { index: true, lazy: async () => ({ Component: (await import('./search-page')).default }) },
];
